import React, { useState } from 'react';
import './MonthlyRentalSingle.css';

import { FaqItem, Lightbox, PageTitle, SidebarHeading } from '../../../components';
import { monthlyRental } from '../../../constants';
import { renderIcon } from '../../../utils';

import { BsListCheck } from 'react-icons/bs';
import { FaCheck, FaPencilRuler } from 'react-icons/fa';
import { IoConstruct } from 'react-icons/io5';

import { Link, useLocation } from 'react-router-dom';

 
  
const MonthlyRentalSingle = () => { 
 
  const location = useLocation();  
  const monthlyRantelSingle = location.state; 

  // State to manage the active accordion for container 1
  const [activeAccordionId, setActiveAccordionId] = useState(null);

  // Function to handle accordion click event for container 1
  const handleAccordionClick = (id) => {
    setActiveAccordionId((prevId) => (prevId === id ? null : id));
  };

  return (
    <>
      {/* Page Title */}
      <PageTitle title={'停車月租服務'} page={'service single'} />

      <section className='service-single'>

        <div className='sidebar service-sidebar'>

          <div className='category sidebar-item'>

            <SidebarHeading title={'有月租停車的需求嗎？'} />

            <div className='box-container'>
              {monthlyRental.map(item => {
                return  (                
                /* Link to the individual service page */
                <Link
                  to={{
                    pathname: '/MonthlyRantel/' + item.title,
                  }}
                  location = {{item}}
                  state= {item}
                  key={item.id}
                  className='item'><span><div className='icon'>{renderIcon(item.title)}</div>{item.title}</span> {/* Service Title */}
                </Link> )
              })}
            </div>

            </div>

        </div>

        <div className='service-info'>

          {/* Service Image */} 
          <div className='image'>
            <img src={monthlyRantelSingle.image} alt='Blog' />
          </div>

          <div className='content'>

            {/* Service heading */}
            <h3 className='main-heading'>{monthlyRantelSingle.title}</h3>

            {/* Service Content */}
            {monthlyRantelSingle.paragraphs.map((paragraph, index) => (
              <p key={index}>{paragraph}</p>
            ))}

          </div>

        </div> 

      </section> 
    </> 
  );
}

export default MonthlyRentalSingle;
